import script from "./informaction.vue?vue&type=script&setup=true&lang=js"
export * from "./informaction.vue?vue&type=script&setup=true&lang=js"

import "./informaction.vue?vue&type=style&index=0&id=1a74fc90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a74fc90"]])

export default __exports__